import { create } from "zustand";
import { api, tokenStore, formatApiError } from "../api/client";

export const useAuth = create((set, get) => ({
  user: null,
  organization: null,
  status: "idle", // 'idle' | 'loading' | 'authenticated' | 'unauthenticated'

  bootstrap: async () => {
    if (!tokenStore.get()) {
      // intentar refresh por si tiene cookie
      try {
        const r = await api.post("/auth/refresh");
        tokenStore.set(r.data.access_token);
      } catch (e) {
        set({ status: "unauthenticated" });
        return;
      }
    }
    try {
      set({ status: "loading" });
      const { data } = await api.get("/me");
      set({ user: data.user, organization: data.organization, status: "authenticated" });
    } catch (e) {
      tokenStore.clear();
      set({ status: "unauthenticated" });
    }
  },

  login: async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    tokenStore.set(data.access_token);
    set({ user: data.user, organization: data.organization, status: "authenticated" });
    return data;
  },

  register: async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    tokenStore.set(data.access_token);
    set({ user: data.user, organization: data.organization, status: "authenticated" });
    return data;
  },

  logout: async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    tokenStore.clear();
    set({ user: null, organization: null, status: "unauthenticated" });
  },

  refreshMe: async () => {
    const { data } = await api.get("/me");
    set({ user: data.user, organization: data.organization });
  },

  setOrganization: (org) => set({ organization: org }),
  setUser: (user) => set({ user }),
}));

export { formatApiError };
